// React Dependencies
import React, { useEffect, useRef, useState } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { extend, useThree } from '@react-three/fiber';
import { DragControls } from 'three/examples/jsm/controls/DragControls';

// Internal Dependencies
import { IsEmpty } from '../../../common/checks';

extend({ DragControls });

const Draggable = (props) => {
  const groupRef = useRef();
  const { camera, gl } = useThree();

  const [objects, setObjects] = useState();

  useEffect(() => {
    setObjects(groupRef.current.children);
  }, [groupRef]);

  return (
    <group name={props.name} ref={groupRef}>
      { !IsEmpty(objects) && props.enableMove && (
        <dragControls args={[objects, camera, gl.domElement]} />
      )}
      {props.children}
    </group>
  );
};

Draggable.propTypes = {
  name:       PropTypes.string,
  enableMove: PropTypes.bool.isRequired,
  children:   PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

Draggable.defaultProps = {
  name:     '',
  children: null,
};

export default Draggable;
